<div class="home-page">
  <div class="bg-color3 home-page-bg">
    <div class="content-width home-point-gallery-section" #dataLoading="appIsLoading" [appIsLoading]="loadingService.isLoading(this)">
      <div class="flex-1 home-page-slide rightPane p-4">
        <p class="page-header mb-4" *ngIf="!isWebInMobileView">Cash Rewards Transactions</p>
        <div class="bg-color2 p-4 accordion-custom-section">
          <div ngbAccordion [closeOthers]="true">
            <div [ngbAccordionItem]="i" *ngFor="let item of transactions; let i = index" [collapsed]="i !== 0">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="d-flex justify-content-between align-items-center flex-gap-5 w-100">
                    <p class="product-name mb-0">Transaction #{{item?.transactionId}} - <span class="font-light">{{item?.status}}</span></p>
                    <i class="fa-solid"></i>
                    <i class="fa-solid"></i>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <div class="mb-4 container-item p-4">
                    <div class="parent-div justify-content-between d-flex flex-column flex-md-row pt-3">
                      <div class="column-left mb-2 mb-md-0">Transaction Date</div>
                      <div class="column-right text-break">{{ item?.transactionDate | date:'yyyy-MM-ddTHH:mm:ss' }}</div>
                    </div>
                    <hr>
                    <div class="parent-div justify-content-between d-flex pt-3">
                      <div class="column-left">Points</div>
                      <div class="column-right">{{item?.points}}</div>
                    </div>
                    <hr>
                    <div class="parent-div justify-content-between d-flex pt-3">
                      <div class="column-left">Cash Payout</div>
                      <div class="column-right">{{item?.cashPayout}}</div>
                    </div>
                    <hr>
                    <div class="parent-div justify-content-between d-flex pt-3">
                      <div class="column-left">TDS</div>
                      <div class="column-right">{{item?.tds}}</div>
                    </div>
                    <hr>
                    <div class="parent-div justify-content-between d-flex pt-3">
                      <div class="column-left">Service Fee</div>
                      <div class="column-right">{{item?.serviceFee}}</div>
                    </div>
                    <hr>
                    <div class="parent-div justify-content-between d-flex pt-3" >
                      <div class="column-left">Reason</div>
                      <div class="column-right">{{item?.reason}}</div>
                    </div>
                    <hr>
                    <div class="parent-div justify-content-between d-flex pt-3">
                      <div class="column-left">UTR</div>
                      <div class="column-right">{{item?.utr || '-'}}
                      </div>
                    </div>
                    <hr>
                    <div class="parent-div justify-content-between d-flex pt-3">
                      <div class="column-left">Bank Account</div>
                      <div class="column-right">{{item?.bankAccount}}</div>
                    </div>
                    <hr>
                    <div class="parent-div justify-content-between d-flex pt-3">
                      <div class="column-left">IFSC</div>
                      <div class="column-right">{{item?.ifsc}}</div>
                    </div>
                    <hr>
                    <div class="parent-div justify-content-between d-flex flex-column flex-md-row pt-3">
                      <div class="column-left mb-2 mb-md-0">User</div>
                      <div class="column-right text-break">
                        <span class="d-block d-md-inline">{{item?.userName}}</span>
                        <span class="d-block d-md-inline text-muted"> ({{item?.mobile}} | {{item?.email}})</span>
                      </div>
                    </div>
                    <div class="py-5">
                      <div class="order-status-section" [ngClass]="{'status-cancelled': (item?.status || '').toLowerCase() === 'failed'}">
                        <p class="mb-0 text-center py-3">{{item?.status}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <p class="mb-0 p-4" *ngIf="transactions?.length == 0">No records found</p>
          </div>

          <div class="pt-4" *ngIf="transactions && transactions.length > 0">
            <div class="col-lg-12 pagination-center-Bottom">
              <cs-custom-pagination [paginationDetails]="paginationDetails" (onChangeEvent)="onChange($event)"></cs-custom-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="home-left leftPane" *ngIf="!isWebInMobileView">
        <cs-profile-point-card theme="theme-white" buttonTheme="theme2"></cs-profile-point-card>
        <cs-most-redeem-products [singleView]="true"></cs-most-redeem-products>
      </div>
    </div>
  </div>
</div>

